import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaFilter } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import { CSVLink } from 'react-csv';

import ApiUiController from '../../controller/ApiUiController';
import ReportAPI from '../../api/ReportAPI';
import Const from '../../util/Constants';
import FilterPannel from '../filter/FilterPannel';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Button from 'react-bootstrap/Button';
import FilterDate from '../filter/FilterDate';
import FieldController from '../../controller/FieldController';

class ConsolidatedActivity extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    
    this.data = [];
    this.filters = [{ field: 'date_time', condition: FieldController.In, 
      value: FilterDate.getValue(FieldController.ThisMonth) }];
    this.fields = { ...this.models.call.fields };
    const keys = Object.keys(this.fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i] !== 'responsible_person' && keys[i] !== 'date_time') {
        delete this.fields[keys[i]];
      }
    }
    this.users = this.models.user.options;
    this.Restrict = Util.isAllow(this.models.lead.permission, Const.PermRestricAcc);
    if(this.Restrict) {
      let value = `${Const.Opt}${[ user.user_id, ...user.child].join(Const.Opt)}${Const.Opt}`;
      this.filters.push({ field: 'responsible_person', type: 'multiselect~user',
        condition: 'in', value });
      this.users = this.users.filter(usr => value.includes(`${Const.Opt}${usr.id}${Const.Opt}`));
    }
    this.state = { inApiCall: true, isFilterOpen: true };
  }

  componentDidMount() { this.loadReport(); }

  loadReport = () => {
    this.isCall = false;
    this.isMeeting = false;
    this.isMeetingCreated = false;

    this.loadCalls();
    this.loadMeetings();
    this.loadMeetingCreated();
    this.setState({ ...this.state, inApiCall: true });
  }

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onFilterChange = filters => {
    this.filters = filters;
    this.loadReport();
  }

  loadCalls = () => {
    const type = 2;
    const x = 'complete';
    const y = 'responsible_person';
    const z = '';
    ReportAPI.reportData(type, 'call', x, y, z, this.filters, this.onCallData, this.onFail);
  }
  onCallData = res => { this.isCall = true; this.calls = res; this.onData(); };

  loadMeetings = () => {
    const type = 2;
    const x = 'complete';
    const y = 'responsible_person';
    const z = '';
    ReportAPI.reportData(type, 'meeting', x, y, z, this.filters, this.onMeetingData, this.onFail);
  }
  onMeetingData = res => { this.isMeeting = true; this.meetings = res; this.onData(); };

  loadMeetingCreated = () => {
    const type = 1;
    const x = '';
    const y = 'created_by';
    const z = '';
    ReportAPI.reportData(type, 'meeting', x, y, z, this.filters, this.onMeetingCreated, this.onFail);
  }
  onMeetingCreated=res=>{this.isMeetingCreated = true; this.meetingCreated = res; this.onData();};

  onData = () => {

    this.data = [[ 'No', 'Users', 'Calls Completed', 'Calls Pending', 'Meetings Attended', 
      'Meetings Pending', 'Meetings Created/Generated' ]];
    for(let i = 0; i < this.users.length; i++) {
      this.data.push([ this.users[i].id, this.users[i].name, 0, 0, 0, 0, 0 ]);
    }
    if(this.isCall && this.isMeeting && this.isMeetingCreated) {
      for(let i = 0; i < this.calls.length; i++) {
        const row = this.data.find(itm => itm[0] === this.calls[i].responsible_person);
        if(row && this.calls[i].complete === 1) { row[2] = row[2] + this.calls[i].sum; }
        else if(row && this.calls[i].complete === 0) { row[3] = row[3] + this.calls[i].sum; }
      }

      for(let i = 0; i < this.meetings.length; i++) {
        const row = this.data.find(itm => 
          this.meetings[i].responsible_person.includes(`${Const.Opt}${itm[0]}${Const.Opt}`));
        if(row && this.meetings[i].complete === 1) { row[4] = row[4] + this.meetings[i].sum; }
        else if(row && this.meetings[i].complete === 0) { row[5] = row[5] + this.meetings[i].sum; }
      }

      for(let i = 0; i < this.meetingCreated.length; i++) {
        const row = this.data.find(itm => itm[0] === this.meetingCreated[i].created_by);
        if(row) { row[6] = row[6] + this.meetingCreated[i].sum; }
      }
      this.data.push([ '', 'Total', 0, 0, 0, 0, 0 ]);
      for(let i = 1; i < this.data.length - 1; i++) {
        for(let j = 2; j < this.data[i].length; j++) {
          this.data[this.data.length - 1][j] += this.data[i][j];
        }
      } 
      this.setState({ ...this.state, inApiCall: false });
    }
  }

  loadView = (row, col) => {
    if(row === this.data.length - 1) return;

    const filters = [ ...this.filters ];
    if(col === 2) {
      const value = `${Const.Opt}${this.data[row][0]}${Const.Opt}`;
      const filt = filters.find(filt => filt.field === 'responsible_person');
      if(filt) { filt.condition = 'in'; filt.value = value;}
      else filters.push({ field: 'responsible_person', type: 'select~user',
      condition: 'in', value });
      filters.push({ field: 'complete', type: 'complete', condition: 'not-in' });
      this.props.navigate(`/call?filters=${JSON.stringify(filters)}`);
    }  else if(col === 3) {
      const value = `${Const.Opt}${this.data[row][0]}${Const.Opt}`;
      const filt = filters.find(filt => filt.field === 'responsible_person');
      if(filt) { filt.condition = 'in'; filt.value = value;}
      else filters.push({ field: 'responsible_person', type: 'select~user',
      condition: 'in', value });
      filters.push({ field: 'complete', type: 'complete', condition: 'in' });
      this.props.navigate(`/call?filters=${JSON.stringify(filters)}`);
    } if(col === 4) {
      const value = `${Const.Opt}${this.data[row][0]}${Const.Opt}`;
      const filt = filters.find(filt => filt.field === 'responsible_person');
      if(filt) { filt.condition = 'in'; filt.value = value;}
      else filters.push({ field: 'responsible_person', type: 'multiselect~user',
      condition: 'in', value });
      filters.push({ field: 'complete', type: 'complete', condition: 'not-in' });
      this.props.navigate(`/meeting?filters=${JSON.stringify(filters)}`);
    }  else if(col === 5) {
      const value = `${Const.Opt}${this.data[row][0]}${Const.Opt}`;
      const filt = filters.find(filt => filt.field === 'responsible_person');
      if(filt) { filt.condition = 'in'; filt.value = value;}
      else filters.push({ field: 'responsible_person', type: 'multiselect~user',
      condition: 'in', value });
      filters.push({ field: 'complete', type: 'complete', condition: 'in' });
      this.props.navigate(`/meeting?filters=${JSON.stringify(filters)}`);
    } else if(col === 6) {
      const value = `${Const.Opt}${this.data[row][0]}${Const.Opt}`;
      const filt = filters.find(filt => filt.field === 'responsible_person');
      if(filt) { filt.condition = 'in'; filt.value = value;}
      else filters.push({ field: 'created_by', type: 'select~user',
      condition: 'equals', value });
      this.props.navigate(`/meeting?filters=${JSON.stringify(filters)}`);
    }
  }
  
  render() {
    const body = [];
    for(let i = 1; i < this.data.length; i++) {
      const item = [ <td key={`body_${i}_${0}`}>{i+1}</td>, 
        <td key={`body_${i}_${1}`}>{this.data[i][1]}</td> ];
      for(let j = 2; j < this.data[i].length; j++) {
        item.push(<td key={`body_${i}_${j}`} onClick={()=>this.loadView(i, j)}>{this.data[i][j]}</td>);
      }
      body.push(<tr key={`body_${i}`}>{item}</tr>);
    }
    return(
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">  
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">{this.props.report.name}</div>
                <div className="col-md-6">
                  <CSVLink data={this.data}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button"
                      onClick={() => this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen})}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th rowSpan="2">No</th>
                        <th rowSpan="2">Users</th>
                        <th colSpan="2">Calls</th>
                        <th colSpan="2">Site Visits (Attended)</th>
                        <th rowSpan="2">Site Visits (Created/Generated)</th>
                      </tr>
                      <tr><th>Complete</th><th>Pending</th><th>Complete</th><th>Pending</th></tr>
                    </thead>
                    <tbody className="listlead"> {body} </tbody>
                  </Table>
                </div>
                { this.state.isFilterOpen ?
                  <FilterPannel filters={this.filters} fields={this.fields}
                    onFilterChange={this.onFilterChange} isFilterOpen={true} restrict={this.Restrict} />
                  : null
                }
              </div>
            </div>  
            
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ConsolidatedActivity);